// extracted by mini-css-extract-plugin
export default {"calculate-button":"calculateButton_calculate-button__GfSBM"};